import { render, staticRenderFns } from "./listDiscount.vue?vue&type=template&id=40bb1dbb&"
import script from "./listDiscount.vue?vue&type=script&lang=js&"
export * from "./listDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports